<template>
  <div v-if="dataPermohonan.status <= 14">
    <div
      v-if="
        namaRole === 'Operator Desa' ||
          namaRole === 'Kepala Desa' ||
          namaRole === 'Operator Kecamatan' ||
          namaRole === 'Operator Dukcapil' ||
          namaRole === 'Operator Dukcapil Kecamatan'
      "
    >
      <h4 class="section-title">
        Validasi
      </h4>
      <hr>
      <div class="form-group row">
        <label
          for=""
          class="col-md-3 text-md-right text-left"
        >Keputusan</label>
                
        <div class="col-md-9">
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="kValid"
              name="keputusan"
              class="custom-control-input" 
              :value="value.valid"
              v-model="form.keputusan" 
              :disabled="isTidakBisaSetValid"
            >
            <label
              class="custom-control-label"
              for="kValid"
            >
              <i class="fa fa-check mr-2 text-success" />
              <b>Valid</b><br>
              <small class="text-muted">Set permohonan valid, sehingga dapat dilanjutkan ke proses berikutnya</small>
            </label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="kRevisi"
              name="keputusan"
              class="custom-control-input"
              :value="value.revisi"
              v-model="form.keputusan"
              :disabled="isTidakBisaSetRevisi"
            >
            <label
              class="custom-control-label"
              for="kRevisi"
            >
              <i class="fa fa-info-circle mr-2 text-warning" />
              <b>Revisi</b><br>
              <small class="text-muted">Minta pemohon untuk memperbaiki data</small>
            </label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="kTolak"
              name="keputusan"
              class="custom-control-input"
              :value="value.tolak"
              v-model="form.keputusan"
              :disabled="isTidakBisaSetTolak"
            >
            <label
              class="custom-control-label"
              for="kTolak"
            >
              <i class="fa fa-times mr-2 text-danger" />
              <b>Tolak</b><br>
              <small class="text-muted">Tolak permohonan</small>
            </label>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-md-3 text-md-right text-left">Tambahkan Keterangan</label>
        <div class="col-md-9">
          <textarea
            class="form-control"
            placeholder="Keterangan"
            v-model="form.keterangan"
            :disabled="form.keputusan === 5 || form.keputusan === 9 || form.keputusan === 14 || dataPermohonan.status >= 14"
          />
        </div>
      </div>


      <!-- tombol validasi operator desa -->
      <div
        class="form-group row"
        v-if="namaRole === 'Operator Desa' && dataPermohonan.status <=5"
      >
        <div class="col-md-9 offset-md-3">
          <button
            v-if="dataPermohonan.status < 14"
            class="btn btn-primary"
            @click="simpanValidasi($event)"
          >
            <i class="fa fa-check mr-2" />Simpan
          </button>
        </div>
      </div>

      <!-- tombol validasi operator kades -->
      <div
        class="form-group row"
        v-if="namaRole === 'Kepala Desa' && dataPermohonan.status <=5"
      >
        <div class="col-md-9 offset-md-3">
          <button
            v-if="dataPermohonan.status < 14"
            class="btn btn-primary"
            @click="simpanValidasi($event)"
          >
            <i class="fa fa-check mr-2" />Simpan
          </button>
        </div>
      </div>

      <!-- tombol validasi operator kecamatan -->
      <div
        class="form-group row"
        v-if="namaRole === 'Operator Kecamatan' && dataPermohonan.status <=9 && dataPermohonan.paket_layanan.is_valid_kecamatan === 1"
      >
        <div class="col-md-9 offset-md-3">
          <button
            v-if="dataPermohonan.status < 14"
            class="btn btn-primary"
            @click="simpanValidasi($event)"
          >
            <i class="fa fa-check mr-2" />Simpan
          </button>
        </div>
      </div>

      <!-- tombol validasi operator dukcapil -->
      <div
        class="form-group row"
        v-if="namaRole === 'Operator Dukcapil' && dataPermohonan.status <=14"
      >
        <div class="col-md-9 offset-md-3">
          <button
            v-if="dataPermohonan.status < 14"
            class="btn btn-primary"
            @click="simpanValidasi($event)"
          >
            <i class="fa fa-check mr-2" />Simpan
          </button>
        </div>
      </div>
            
      <!-- tombol validasi operator dukcapil kecamatan -->
      <div
        class="form-group row"
        v-if="namaRole === 'Operator Dukcapil Kecamatan' && dataPermohonan.status <=14"
      >
        <div class="col-md-9 offset-md-3">
          <button
            v-if="dataPermohonan.status < 14"
            class="btn btn-primary"
            @click="simpanValidasi($event)"
          >
            <i class="fa fa-check mr-2" />Simpan
          </button>
        </div>
      </div>
    </div>

    <div v-if="konfirmasiValid">
      <div
        v-if="
          namaRole === 'Operator Desa' ||
            namaRole === 'Kepala Desa' ||
            namaRole === 'Operator Kecamatan' ||
            namaRole === 'Operator Dukcapil' ||
            namaRole === 'Operator Dukcapil Kecamatan'
        "
      >
        <h4 class="section-title">
          Lanjutkan Proses
        </h4>
        <hr>

        <div class="alert alert-primary alert-has-icon mt-3">
          <div class="alert-icon">
            <i class="far fa-lightbulb" />
          </div>
          <div class="alert-body">
            <div class="alert-title">
              Informasi
            </div>
            Anda sudah menyatakan permohonan valid. Anda masih bisa mengubah keputusan validasi selama belum menekan tombol
            "Lanjut Ke Tahap Berikutnya". Apabila sudah menekan tombol "Lanjut Ke Tahap Berikutnya" anda tidak dapat mengubah 
            status validasi.
          </div>
        </div>

        <button
          class="btn btn-primary"
          @click="simpanValidasiKonfirmasi($event)"
        >
          <i class="fa fa-check mr-2" />Lanjut Ke Tahap Berikutnya
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  data() {
    return {
      // form validasi
      form: {
        keputusan: null,
        keterangan: null
      },
      value: {
        valid: null,
        revisi: null,
        tolak: null
      },
      isTidakBisaSetValid: false, // jika semua berkas statusnya 1, baru bisa valid
      isTidakBisaSetRevisi: false, // jika tidak ada berkas yg belum diproses, dan ada berkas yang revisi
      isTidakBisaSetTolak: false,

      konfirmasiValid: false, // ini adalah tombol untuk validasi, 
    }
  },
  computed: {
    dataPermohonan() {
      return this.$store.getters.getDataPermohonan
    },
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    },
    filePermohonan() {
      return this.$store.getters.getFilePermohonan
    }

  },
  methods: {
    simpanValidasi(e) {
      if (this.namaRole === 'Penduduk') {
        swal({
          title: "Gagal",
          text: "Anda tidak memiliki izin",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }

      // disini validasi ada konfirmasi lanjutan.
      // 1 muncul alert yakin atau tidak
      // 2 setelah yakin, di front end muncul lagi konfirmasi lanjut ke tahap berikutnya
      // 3 setelah klik lanjut, baru set valid.

      // jadi konfirmasi lanjutan hanya jika di set valid

      swal({
        title: "Konfirmasi",
        text: "Yakin ingin menyimpan hasil validasi?",
        icon: "warning",
        buttons: {
          cancel: "Batal",
          ok: {
            text: "Yakin, simpan",
            value: "ok",
          },
        }
      }).then(val => {
        if (val === 'ok') {
          if (this.form.keputusan == 5 || this.form.keputusan == 9 || this.form.keputusan == 14) {
            // munculkan tombol lanjut ke tahap berikutnya
            this.konfirmasiValid = true
            swal({
              title: "Berhasil",
              text: "Anda dapat melanjutkan ke tahap berikutnya.",
              icon: "success",
              buttons: "Ok"
            })
          } else {
            // langsung simpan
            this.simpanValidasiFinal(e)
          }
        }
      })
    },
    simpanValidasiKonfirmasi(e) {
      swal({
        title: "Konfirmasi",
        text: "Yakin ingin melanjutkan ke tahap berikutnya? Tindakan ini bersifat final dan tidak dapat diubah.",
        icon: "warning",
        buttons: {
          cancel: "Batal",
          ok: {
            text: "Yakin, lanjutkan",
            value: "ok",
          },
        }
      }).then(val => {
        if (val === 'ok') {
          // langsung simpan
          this.simpanValidasiFinal(e)

          this.konfirmasiValid = false
        }
      })
    },
    simpanValidasiFinal(e) {
      let button = e.target
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Simpan'

      let formData = new FormData()
      formData.append('status', this.form.keputusan)

      let dispatchValidasi = 'validasiPermohonanByDesa'
      if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
        formData.append('keterangan_desa', this.form.keterangan)
        dispatchValidasi = 'validasiPermohonanByDesa'
      } else if (this.namaRole === 'Operator Kecamatan') {
        formData.append('keterangan_kecamatan', this.form.keterangan)
        dispatchValidasi = 'validasiPermohonanByKecamatan'
      } else if (this.namaRole === 'Operator Dukcapil' || this.namaRole === 'Operator Dukcapil Kecamatan') {
        formData.append('keterangan_dukcapil', this.form.keterangan)
        dispatchValidasi = 'validasiPermohonanByDukcapil'
      }

      let idDataPermohonan = this.dataPermohonan.id_data_permohonan

      this.$store.dispatch(dispatchValidasi, { id: idDataPermohonan, form: formData }).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
            this.$store.dispatch('showDataPermohonanPendudukByDesa', idDataPermohonan)
          } else if (this.namaRole === 'Operator Kecamatan') {
            this.$store.dispatch('showDataPermohonanPendudukByKecamatan', idDataPermohonan)
          } else if (this.namaRole === 'Operator Dukcapil' || this.namaRole === 'Operator Dukcapil Kecamatan') {
            this.$store.dispatch('showDataPermohonanPendudukByDukcapil', idDataPermohonan)
          }


          let dataNotif = this.getTitleBodyNotif()

          this.notify({
            type_notif: 'STATUS_PERMOHONAN',
            type_receiver: 'penduduk',
            id_penduduk: this.dataPermohonan.id_penduduk,
            id_data_permohonan: idDataPermohonan,
            status_permohonan: this.form.keputusan,
            via: 'mail,fcm',
            title_notif: dataNotif.title_notif,
            body_notif: dataNotif.body_notif
          })

        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      }).catch(err => {
        // console.log(err)
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      })
    },
    notify(data) {
      let formData = new FormData
      for (let key in data) {
        formData.append(key, data[key])
      }

      this.$store.dispatch('sendNotifikasi', formData).then(r => {
        // console.log(r)
      })
    },
    getTitleBodyNotif() {
      let title_notif = ''
      let body_notif = ''
      let nama_layanan = this.dataPermohonan.paket_layanan.layanan.nama_layanan

      if (this.form.keputusan == 3 || this.form.keputusan == 7 || this.form.keputusan == 11) {
        title_notif = 'Permohonan Anda Perlu Diperbaiki'
        body_notif = `Permohonan ${nama_layanan} yang anda ajukan, perlu diperbaiki`
      } else if (this.form.keputusan == 4 || this.form.keputusan == 8 || this.form.keputusan == 12) {
        title_notif = 'Permohonan Anda Ditolak'
        body_notif = `Permohonan ${nama_layanan} yang anda ajukan, telah ditolak`
      } else if (this.form.keputusan == 5 || this.form.keputusan == 9 || this.form.keputusan == 14) {
        title_notif = 'Permohonan Anda Sudah Divalidasi'
        body_notif = `Permohonan ${nama_layanan} yang anda ajukan, telah divalidasi`
      }
      return {
        title_notif: title_notif,
        body_notif: body_notif
      }
    },
    checkValidasiFile() {
      if (this.namaRole != 'Penduduk') {
        let allValid = true
        this.filePermohonan.forEach(e => {
          if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
            if (e.is_valid_desa != 1) {
              allValid = false
            }
            if (this.dataPermohonan.status >= 5) {
              allValid = true
            }
          } else if (this.namaRole === 'Operator Kecamatan') {
            if (e.is_valid_kecamatan != 1) {
              allValid = false
            }
            if (this.dataPermohonan.status >= 9) {
              allValid = true
            }
          } else if (this.namaRole === 'Operator Dukcapil' || this.namaRole === 'Operator Dukcapil Kecamatan') {
            if (e.is_valid_dukcapil != 1) {
              allValid = false
            }
            if (this.dataPermohonan.status >= 14) {
              allValid = true
            }
          }

        })

        let hasBelumProses = false
        this.filePermohonan.forEach(e => {
          if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
            if (e.is_valid_desa === 0 || e.is_valid_desa === null) {
              if (e.file) {
                // biasanya jika perlu berkas tambahan, di upload file kosong
                hasBelumProses = true
              }
            }
            if (this.dataPermohonan.status >= 5) {
              hasBelumProses = false
              this.isTidakBisaSetTolak = true
            }
          } else if (this.namaRole === 'Operator Kecamatan') {
            if (e.is_valid_kecamatan === 0 || e.is_valid_kecamatan === null) {
              if (e.file) {
                // biasanya jika perlu berkas tambahan, di upload file kosong
                hasBelumProses = true
              }
            }
            if (this.dataPermohonan.status >= 9) {
              hasBelumProses = false
              this.isTidakBisaSetTolak = true
            }
          } else if (this.namaRole === 'Operator Dukcapil' || this.namaRole === 'Operator Dukcapil Kecamatan') {
            if (e.is_valid_dukcapil === 0 || e.is_valid_dukcapil === null) {
              if (e.file) {
                // biasanya jika perlu berkas tambahan, di upload file kosong
                hasBelumProses = true
              }
            }
            if (this.dataPermohonan.status >= 14) {
              hasBelumProses = false
              this.isTidakBisaSetTolak = true
            }
          }
        })

        let valueKeputusan = this.getValueKeputusan()
        if (hasBelumProses) {
          this.isTidakBisaSetValid = true
          this.isTidakBisaSetRevisi = true
        } else {
          if (allValid) { // bisa check valid
            this.isTidakBisaSetValid = false

            this.isTidakBisaSetRevisi = true

            // check keputusan valid
            this.form.keputusan = valueKeputusan.valid

          } else { // bisa check revisi
            this.isTidakBisaSetValid = true
            this.isTidakBisaSetRevisi = false

            // check keputusan revisi
            this.form.keputusan = valueKeputusan.revisi
          }
        }
      }
    },
    getValueKeputusan() {
      let ruleValidasi = this.dataPermohonan.paket_layanan
      let valValid = ''
      let valRevisi = ''
      let valTolak = ''
      if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
        if (ruleValidasi.is_valid_kecamatan === 1) {
          valValid = 5
        } else if (ruleValidasi.is_valid_kecamatan === 0 && ruleValidasi.is_valid_dukcapil === 1) {
          valValid = 9
        }
        valRevisi = 3
        valTolak = 4
      } else if (this.namaRole === 'Operator Kecamatan') {
        valValid = 9
        valRevisi = 7
        valTolak = 8
      } else if (this.namaRole === 'Operator Dukcapil' || this.namaRole === 'Operator Dukcapil Kecamatan') {
        valValid = 14
        valRevisi = 11
        valTolak = 12
      }

      return {
        valid: valValid,
        revisi: valRevisi
      }
    },
    setRuleValidasi(newVal) {
      // set rule validasi
      let ruleValidasi = this.dataPermohonan.paket_layanan
      if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
        if (newVal.status >= 5) {
          if (ruleValidasi.is_valid_kecamatan == 1) {
            this.form.keputusan = 5
          } else if (ruleValidasi.is_valid_kecamatan == 0 && ruleValidasi.is_valid_dukcapil == 1) {
            this.form.keputusan = 9
          }
        } else {
          this.form.keputusan = this.dataPermohonan.status
        }

        this.form.keterangan = (this.dataPermohonan.keterangan_desa) ? this.dataPermohonan.keterangan_desa : ''

      } else if (this.namaRole === 'Operator Kecamatan') {
        if (newVal.status >= 9) {
          this.form.keputusan = 9
        } else {
          this.form.keputusan = this.dataPermohonan.status
        }
        this.form.keterangan = (this.dataPermohonan.keterangan_kecamatan) ? this.dataPermohonan.keterangan_kecamatan : ''

      } else if (this.namaRole === 'Operator Dukcapil' || this.namaRole === 'Operator Dukcapil Kecamatan') {
        if (this.dataPermohonan.status >= 14) {
          this.form.keputusan = 14
        } else {
          this.form.keputusan = this.dataPermohonan.status
        }

        this.form.keterangan = (this.dataPermohonan.keterangan_dukcapil) ? this.dataPermohonan.keterangan_dukcapil : ''
      }
    },
    setValueValidasi(newVal) {
      // set value valid, revisi, tolak

      let ruleValidasi = this.dataPermohonan.paket_layanan

      let valValid = ''
      let valRevisi = ''
      let valTolak = ''
      if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
        if (ruleValidasi.is_valid_kecamatan === 1) {
          valValid = 5
        } else if (ruleValidasi.is_valid_kecamatan === 0 && ruleValidasi.is_valid_dukcapil === 1) {
          valValid = 9
        }
        valRevisi = 3
        valTolak = 4
      } else if (this.namaRole === 'Operator Kecamatan') {
        valValid = 9
        valRevisi = 7
        valTolak = 8
      } else if (this.namaRole === 'Operator Dukcapil' || this.namaRole === 'Operator Dukcapil Kecamatan') {
        valValid = 14
        valRevisi = 11
        valTolak = 12
      }

      // console.log(this.form.keputusan)
      // console.log(valValid, valRevisi, valTolak)


      this.value.valid = valValid
      this.value.revisi = valRevisi
      this.value.tolak = valTolak
    }
  },
  created() {
    this.konfirmasiValid = false

    if (this.filePermohonan) {
      this.checkValidasiFile()
    }

    if (this.dataPermohonan) {
      this.setRuleValidasi(this.dataPermohonan)

      this.setValueValidasi(this.dataPermohonan)

    }
  },
  watch: {
    dataPermohonan(newVal) {
      this.setRuleValidasi(newVal)

      this.setValueValidasi(newVal)
    },
    filePermohonan(newVal) {
      // console.log(newVal)
      // console.log(newVal.findIndex(e => e.dokumen.kode_dokumen === 'F1.02'))
      this.checkValidasiFile()
    },
    'form.keputusan': function (newVal) {
      if (newVal === 5 || newVal === 9 || newVal === 14) {
        this.form.keterangan = ''
      }

      // tombol lanjutkan di hilangkan dulu
      this.konfirmasiValid = false
    },
  }
}
</script>